;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"8e4fc5a1f90be2e5c3c3a1bfaf389572d2925d89"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

Sentry.init({
  environment: publicRuntimeConfig.stage,
  dsn: publicRuntimeConfig.sentryDsnFe,
  tracesSampleRate: 1.0,
});
